import actions from '@/store/templates/actions';

const templatesModule = {
  state: () => ({
    messagesTemplates: [],
    smsTemplates: {
      data: [],
      count: 0,
    },
    isLoading: false,
    total: 0,
    error: '',
  }),
  mutations: {
    SMS_START(state) {
      state.isLoading = true;
    },
    SMS_SUCCESS(state) {
      state.isLoading = false;
    },
    SMS_FAILURE(state, payload) {
      state.isLoading = false;
      state.error = payload;
    },
    GET_SMS_START(state) {
      state.isLoading = true;
    },
    GET_SMS_SUCCESS(state, payload) {
      state.isLoading = false;
      state.smsTemplates = payload;
    },
    GET_SMS_FAILURE(state, payload) {
      state.isLoading = false;
      state.error = payload;
    },
    GET_MESSAGES_TEMPLATES_START(state) {
      state.isLoading = true;
      state.error = null;
    },
    GET_MESSAGES_TEMPLATES_SUCCESS(state, payload) {
      const {
        data,
        total,
      } = payload;

      state.isLoading = false;
      state.messagesTemplates = data;
      state.total = total;
      state.error = null;
    },
    GET_MESSAGES_TEMPLATES_FAILURE(state, payload) {
      state.isLoading = false;
      state.error = payload;
    },
  },
  actions,
  namespaced: true,
};

export default templatesModule;
